import { render } from "./link-user.vue?vue&type=template&id=906ac7de"
import script from "./link-user.vue?vue&type=script&lang=js"
export * from "./link-user.vue?vue&type=script&lang=js"

import "./link-user.vue?vue&type=style&index=0&id=906ac7de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__